<template>
  <div class="login-page-wrapper">
    <div class="login-page container">
      <div class="login-header">
        <div class="logo">
          <img src="@/assets/logo.svg" />
        </div>
        <div class="tiles">
          <span class="tile back-olive"></span>
          <span class="tile back-black"></span>
          <span class="tile back-green"></span>
          <span class="tile back-off-green"></span>
        </div>
      </div>

      <div class="container px-4 mb-4">
        <h1 class="is-size-1 mr-5">{{ $t("login.title") }}</h1>
        <form action="#" method="post" @submit.prevent="submit">
          <div class="field mb-4">
            <div class="control">
              <label>{{ $t("login.labels.vat_number") }}</label>
              <input
                v-model="vatNumber"
                class="input"
                type="text"
                required
                :placeholder="$t('login.placeholder.vat_number')"
                autofocus
              />
              <ul v-if="errors.vat_number" class="help is-warning mt-2">
                <li v-for="(error, index) in errors.vat_number" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>

          <div class="field mb-4">
            <div class="control">
              <label>{{ $t("login.labels.password") }}</label>
              <input
                v-model="password"
                class="input"
                type="password"
                required
                :placeholder="$t('login.placeholder.password')"
              />
              <ul v-if="errors.password" class="help is-warning mt-2">
                <li v-for="(error, index) in errors.password" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>

          <span
            v-if="errors['non_field_errors']"
            class="has-text-warning has-text-weight-semibold"
          >
            {{ errors["non_field_errors"][0] }}
          </span>

          <button type="submit" class="button is-fullwidth">
            {{ $t("login.placeholder.submit") }}
          </button>
        </form>
      </div>

      <div class="container px-4">
        <p class="mb-2">{{ $t("login.password_reset.label") }}</p>
        <router-link :to="{ name: 'password-reset' }">
          <span>{{ $t("login.password_reset.link") }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import { mapActions } from "vuex"

export default {
  name: "login",
  mounted() {
    this.selectedLocale = this.$i18n.locale
    if (this.$route.query.next) {
      this.next = this.$route.query.next
    }
  },
  data() {
    return {
      vatNumber: "",
      password: "",
      selectedLocale: "",
      next: null,
      errors: {},
    }
  },
  methods: {
    ...mapActions(["logIn", "setLocale"]),
    submit: async function () {
      this.errors = {}
      api
        .authenticate(this.vatNumber, this.password)
        .then((response) => {
          let data = response.data
          data.next = this.next
          this.logIn(data)
        })
        .catch((error) => {
          this.errors = error.response ? error.response.data : {}
        })
    },
  },
}
</script>
